<template>
    <div class="flex gap-5">
        <div class="hidden md:flex flex-col items-center mt-2 w-[48px]">
            <div class="w-[48px] flex justify-center" v-if="timeType === 'next'">
              <div class="w-12 h-12 bg-brand-orange rounded-full flex items-center justify-center" :class="{'animate-scale': targetIsVisible}">

              </div>
            </div>

            <div class="w-[48px] flex justify-center" v-else-if="timeType === 'past'">
              <div class="w-12 h-12 bg-brand-orange flex justify-center items-center rounded-full" :class="{'animate-scale': targetIsVisible}">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
                  <path d="M20.9294 0.668218C21.2008 0.389186 21.5701 0.226809 21.9591 0.215465C22.2605 0.206776 22.5576 0.289368 22.8114 0.452434C23.0652 0.615499 23.2639 0.85144 23.3815 1.12938C23.4991 1.40732 23.5301 1.71431 23.4704 2.01017C23.4108 2.30603 23.2633 2.57698 23.0472 2.78757L9.06894 16.776C8.78806 17.057 8.40718 17.2148 8.01004 17.2148C7.6129 17.2148 7.23202 17.057 6.95114 16.776L0.960453 10.781C0.81672 10.6429 0.701968 10.4775 0.622916 10.2944C0.543865 10.1114 0.502103 9.91439 0.500077 9.715C0.498052 9.5156 0.535803 9.31781 0.611119 9.1332C0.686436 8.94858 0.797804 8.78087 0.938701 8.63986C1.0796 8.49886 1.24719 8.38742 1.43167 8.31204C1.61615 8.23667 1.8138 8.19889 2.01305 8.20092C2.2123 8.20295 2.40914 8.24474 2.59205 8.32385C2.77495 8.40296 2.94025 8.51779 3.07825 8.66163L8.01004 13.597L20.9294 0.668218Z" fill="white"/>
                </svg>
              </div>
            </div>

            <div class="w-[48px] flex justify-center" v-else>
              <div class="w-6 h-6 bg-[#111827] rounded-full" :class="{'animate-scale': targetIsVisible}"></div>
            </div>

            <div v-if="hasLine" class="w-1 mt-2 transition-all duration-[1500ms] ease-out rounded-xl bg-brand-gray-900" :class="{'ml-[5px]': timeType === 'past', 'h-full': targetIsVisible, 'h-0': !targetIsVisible}"></div>
        </div>
        <div class="md:hidden flex flex-col items-center mt-2 mr-3">
            <div class="w-[28px] flex justify-center" v-if="timeType === 'past'">
                <div :class="{'animate-scale': targetIsVisible}" class="flex items-center justify-center rounded-full bg-brand-orange w-[28px] h-[28px]">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                    <path d="M10.6905 0.393044C10.8296 0.228074 11.0188 0.132074 11.2181 0.125367C11.3726 0.12023 11.5248 0.169061 11.6548 0.265468C11.7849 0.361876 11.8867 0.501369 11.9469 0.665692C12.0072 0.830015 12.0231 1.01151 11.9925 1.18643C11.9619 1.36135 11.8864 1.52155 11.7756 1.64605L4.6133 9.91632C4.46938 10.0824 4.27422 10.1757 4.07073 10.1757C3.86724 10.1757 3.67208 10.0824 3.52816 9.91632L0.458588 6.37192C0.384941 6.29027 0.326143 6.19247 0.285637 6.08425C0.245132 5.97603 0.223734 5.85957 0.222696 5.74168C0.221658 5.6238 0.241001 5.50686 0.279593 5.39771C0.318184 5.28857 0.375248 5.18941 0.447443 5.10604C0.519638 5.02268 0.605511 4.95679 0.700036 4.91223C0.79456 4.86767 0.895835 4.84533 0.997928 4.84653C1.10002 4.84773 1.20088 4.87244 1.2946 4.91921C1.38832 4.96598 1.47302 5.03387 1.54373 5.11891L4.07073 8.03682L10.6905 0.393044Z" fill="white"/>
                  </svg>
                </div>
            </div>

            <div class="w-[28px] flex justify-center" v-else-if="timeType === 'next'">
              <div :class="{'animate-scale': targetIsVisible}" class="rounded-full bg-brand-orange w-[28px] h-[28px]"></div>
            </div>

          <div class="w-[28px] flex justify-center" v-else>
            <div :class="{'animate-scale': targetIsVisible}" class="rounded-full bg-[#111827] w-[15px] h-[15px]"></div>
          </div>

            <div v-if="hasLine" class="w-1 mt-2 transition-all duration-[1500ms] ease-out rounded-xl bg-brand-gray-900" :class="{'h-full': targetIsVisible, 'h-0': !targetIsVisible}"></div>
        </div>

        <div class="pt-[8px]">
            <p style="font-feature-settings: 'ss02' on;" :class="{'lg:text-[24px] text-[14px]' : timeType === 'future', 'md:text-[32px] text-[19px] font-bold': timeType !== 'future'}">{{ date }}</p>
            <p class="mt-2 font-semibold text-brand-gray-900 md:text-big-body text-[12px]">{{ title }}</p>
            <p class="mt-2 font-medium text-brand-gray-900 md:text-body text-[12px]" :class="{'mb-12': !hasSlot, 'mb-2': hasSlot}">{{ description }}</p>

            <slot />

        </div>

    </div>
</template>

<script>
export default {
    props: {
        date: {
            type: String
        },
        title: {
            type: String
        },
        description: {
            type: String
        },

        //past next future
        timeType: {
            type: String
        },

        hasLine: {
            type: Boolean,
            default: true
        },

        targetIsVisible: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        hasSlot() {
            return this.$slots.default && this.$slots.default().findIndex(o => o.type !== Comment) !== -1;
        }
    }
}
</script>

<style>

</style>
